<template>
  <div id="app">
    <header-comp></header-comp>
    <router-view></router-view>
  </div>
</template>

<script>
import headerComp from './components/headerComp.vue'
export default {
  name: 'App',
  components:{
    headerComp,
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  height: 100%;
}
</style>
